<template>
  <GeoSelectorPage
      v-if="screen === 'selectZone'"
      v-bind:parameters="parameters"
      :screen="screen"
      @zone-selected="zoneSelected"
  />

  <GeoSelectorPage
      v-if="screen === 'selectQuestionInZone'"
      v-bind:parameters="parameters"
      :screen="screen"
      @point-selected="pointSelected"
  />

  <NavigationFrame
      v-if="screen === 'navigateToQuestion'"
      :placeGeo="parameters.question.geo"
      :okRadius="parameters.question.okRadius"
      :placeTitle="parameters.question.title"
      :placeDescription="parameters.question.description"
      :verticalPlaceImageUrl="parameters.question.verticalImageUrl"
      :key="'nav-' + parameters.questionId"
      :audio="parameters.question.audio"
      @in-ok-radius.once="navigatedToPlace"
  />

  <QuizFrameV2
      v-if="state === 'answerQuestion' && screen !== 'answerResult'"
      :quiz-data="parameters.question.quiz"
      :place-title="parameters.question.title"
      :horizontalPlaceImageUrl="parameters.question.horizontalImageUrl"
      :questId="questId"
      :key="'quiz-' + parameters.question.id"
      :questionId="parameters.question.id"
      @got-question-answer="gotQuestionAnswer"
      @nextQuestion="nextQuestion"
      @finishedQuiz="finishedQuiz"
      @apierror="apierror"
      @skipQuestion="askToSkipQuestion"
  />

  <QuizAnswerResultFrame
      v-if="screen === 'answerResult'"
      :answeredCorrectly="parameters.isCorrect"
      :answerDescription="parameters.description"
      :longDescription="parameters.longDescription"
      :nextQuestionButtonText="parameters.nextQuestionButtonText"
      :skipButtonText="parameters.skipButtonText"
      :skipConfirmationText="parameters.skipConfirmationText"
      :gameMechanics="parameters.gameMechanics"
      :canRetryAfterTime="parameters.retryInvalidAnswerAfterTime"
      @nextQuestion="nextQuestion"
      @skip-question="skipQuestion"
      @retry-question="retryQuestion"
  />

  <QuestFinishedPage
      v-if="state === 'finishedCongrats'"
      :quest-id="questId"
      :show-questionnarie="parameters.showQuestionnarie"
      :win="true"
      @setheadervalues="setHeaderValues"
  />

  <QuestionDialog
      v-if="showDialogAskForZoneExit"
      title="Выйти из зоны?"
      text="Вы действительно хотите покинуть зону и выбрать другую? Вы больше не сможете вернуться в эту зону."
      :buttons="skipQuestionButtons"
      @hide="showDialogAskForZoneExit = false"
      @action="exitZoneConfirmed"
  />


  <QuestFinishedPage
      v-if="state === 'timeNotStarted' || state === 'timeFinished'"
      :quest-id="questId"
      :show-questionnarie="parameters.showQuestionnarie ? parameters.showQuestionnarie : false"
      :win="false"
      :message="parameters.text"
      :navigate-to-point="parameters.navigateToPoint"
      @setheadervalues="setHeaderValues"
  />

</template>

<script>
import {apiCall, makeImageUrlAbsolute} from '../../common-functions';
import GeoSelectorPage from "@/components/quest/navigation/GeoSelectorPage.vue";
import NavigationFrame from "@/components/quest/navigation/NavigationFrame.vue";
import QuizFrameV2 from "@/components/quest/quiz/QuizFrameV2.vue";
import QuizAnswerResultFrame from "@/components/quest/quiz/QuizAnswerResultFrame.vue";
import QuestFinishedPage from "@/components/quest/QuestFinishedPage.vue";
import QuestionDialog from "@/components/quest/commonPageElements/QuestionDialog.vue";

export default {
  props: {
    questId: String,
  },
  emits: ['setheadervalues','finishedQuiz','apierror'],
  data() {
    return {
      questionId: null,
      state: 'loading',
      screen: 'loading',
      parameters: {},
      zoneId: null,
      place: {
        titleColor: 'white'
      },
      showDialogAskForQuestionSkip: false,
      skipQuestionButtons: [
        {
          text: 'Да',
          color: 'red'
        },
        'Нет'
      ],
      menuButtonsAvailable: {
        skipQuestion: 'Выбрать другой вопрос',
        exitZone: 'Покинуть зону',
      },
      showDialogAskForZoneExit: false,
      forceStateRefreshTimeout: null
    };
  },

  created() {
    this.getCurrentState();
  },

  computed: {
    cssImageUrl() {
      return 'url("' + makeImageUrlAbsolute(this.place.verticalImageUrl) + '")';
    }
  },

  methods: {
    apierror() {
      this.$emit('apierror');
    },

    setHeaderValues() {
      this.$emit('setheadervalues');
    },

    stateModificationApiCall(url, method, body) {
      const component = this;
      component.state = 'loading';
      apiCall(url, {
        method: method,
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
      })
          .then(response => {
            if (response.ok) {
              return response.json();
            }
            throw new Error('Error in api call', method, url);
          })
          .then(json => {
            this.state = json.state.state;
            this.screen = json.state.screen;
            this.parameters = json.state.parameters;
            this.zoneId = json.state.zoneId;
            this.questionId = json.state.questionId;

            if (json.state.counters) {
              this.$emit('setheadervalues', {
                current: json.state.counters.answeredQuestionsCount + 1,
                complete: json.state.counters.answeredQuestionsCount,
                rest: Math.max(json.state.counters.totalQuestionsCount - json.state.counters.answeredQuestionsCount, 0),
                skipped: json.state.counters.skippedQuestionsCount
              });
            }

            if (json.state.buttons) {
              for (let button in this.menuButtonsAvailable) {
                if (json.state.buttons[button]) {
                  window.vm.$refs.footer.addOptionItem(this.menuButtonsAvailable[button], () => {
                    this[button]();
                  });
                } else {
                  window.vm.$refs.footer.removeOptionItem(this.menuButtonsAvailable[button]);
                }
              }
            }

            if (json.state.forceRefreshTime) {
              if (this.forceStateRefreshTimeout) {
                clearTimeout(this.forceStateRefreshTimeout);
                this.forceStateRefreshTimeout = null;
              }
              if (json.state.forceRefreshTime < json.state.now) return;

              const browserCurrentTime = (new Date()).getTime();
              const browserToServerTimeDiff = browserCurrentTime - json.state.now;
              const timeToQuestEnd = (json.state.forceRefreshTime - json.state.now) - browserToServerTimeDiff;
              const timeForSomeLag = 5000;

              this.forceStateRefreshTimeout = setTimeout(() => {
                this.getCurrentState();
              }, timeToQuestEnd + timeForSomeLag);
            }
          })
          .catch(e => {
            console.error(e);
            component.$emit('apierror');
          });
    },

    getCurrentState() {
      this.stateModificationApiCall('/v2/quest/' + encodeURIComponent(this.questId) + '/currentState', 'GET');
    },

    zoneSelected(zoneId) {
      this.stateModificationApiCall('/v2/quest/' + encodeURIComponent(this.questId) + '/zone-selected', 'POST',{zoneId});
    },

    pointSelected(questionId) {
      this.stateModificationApiCall('/v2/quest/' + encodeURIComponent(this.questId) + '/question-selected', 'POST', {questionId});
    },

    navigatedToPlace() {
      this.stateModificationApiCall('/v2/quest/' + encodeURIComponent(this.questId) + '/question/' + this.questionId + '/state', 'POST', {state: 'quiz'});
    },

    gotQuestionAnswer(answer) {
      this.stateModificationApiCall('/v2/quest/' + encodeURIComponent(this.questId) + '/question/' + this.questionId + '/answer', 'POST',{answer});
    },

    retryQuestion() {
      this.stateModificationApiCall('/v2/quest/' + encodeURIComponent(this.questId) + '/question/' + this.questionId + '/retry', 'POST');
    },

    skipQuestion() {
      this.stateModificationApiCall('/v2/quest/' + encodeURIComponent(this.questId) + '/question/' + this.questionId + '/skip', 'POST');
    },

    nextQuestion() {
      this.stateModificationApiCall('/v2/quest/' + encodeURIComponent(this.questId) + '/question/next', 'POST');
    },

    exitZone() {
      this.showDialogAskForZoneExit = true;
    },

    exitZoneConfirmed(action) {
      this.showDialogAskForZoneExit = false;
      if (action === this.skipQuestionButtons[0].text) {
        this.stateModificationApiCall('/v2/quest/' + encodeURIComponent(this.questId) + '/zone/' + this.zoneId + '/exit', 'POST');
      }
    },










    finishedQuiz(questIsCompleteStatus) {
      this.state = 'finished';
      this.$emit('finishedQuiz', questIsCompleteStatus);
    },

    callApiToSkipQuestion() {
      const component = this;
      const url = '/quest/' + encodeURIComponent(this.questId) + '/question/' + this.questionId + '/skip';
      apiCall(
          url,
          {
            method: 'POST',
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json'
            }
          }
      )
          //todo add load animation
          .then(response => {
            if (response.ok) {
              return response.json();
            }
            throw new Error('Error skipping question');
          })
          .then((json) => {
            if (json.questIsComplete) {
              this.finishedQuiz();
            } else {
              this.nextQuestion();
            }
          })
          .catch(e => {
            console.error(e);
            component.$emit('apierror');
          });
    },
    askToSkipQuestion() {
      if (! window.vm.headerValues.skipped) {
        this.showDialogAskForQuestionSkip = true;
      } else {
        this.callApiToSkipQuestion();
      }
    },
  },

  components: {
    QuestionDialog,
    QuestFinishedPage,
    QuizAnswerResultFrame,
    QuizFrameV2,
    NavigationFrame,
    GeoSelectorPage
  },

  mounted() {
    //todo
    // window.vm.$refs.footer.addOptionItem('Начать квест заново', () => {
    //   console.log('MENUMENU')
    // });
  },

  beforeUnmount() {
    // window.vm.$refs.footer.removeOptionItem('Начать квест заново');
    for (let button in this.menuButtonsAvailable) {
      window.vm.$refs.footer.removeOptionItem(this.menuButtonsAvailable[button]);
    }
    if (this.forceStateRefreshTimeout) {
      clearTimeout(this.forceStateRefreshTimeout);
      this.forceStateRefreshTimeout = null;
    }
  }
}
</script>

<style scoped>
@import '@/scss/loading-animation.scss';

.quest, .place-map {
  height: 100%;
  width: 100%;
}
</style>
